export default "__VITE_ASSET__BZ_$oSfH__"